import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { DEVTOOLS_OPTIONS } from '@/modules/debug/constants/zustand';

type DebugStore = {
  autodeskDebug: boolean;
};

type DebugActions = {
  toggleAutodeskDebug(): void;
};

const INITIAL_STATE: DebugStore = {
  autodeskDebug: false,
};

export const useDebugStore = create<DebugStore & DebugActions>()(
  devtools(
    (set, get) => ({
      ...INITIAL_STATE,

      toggleAutodeskDebug() {
        set(
          {
            autodeskDebug: !get().autodeskDebug,
          },
          undefined,
          {
            type: 'toggleAutodeskDebug',
          },
        );
      },
    }),
    { store: 'debugStore', ...DEVTOOLS_OPTIONS },
  ),
);
